// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import { PlasmicClientsListCard } from "./plasmic/collect_wise_draft/PlasmicClientsListCard";
import { useNavigate } from 'react-router-dom';

function ClientsListCard_(props, ref) {
  const navigate = useNavigate()

  

  return <PlasmicClientsListCard root={{ ref,
  onClick: () => {
    if (props.clientEmail === "sean@collectwise.co" || props.clientEmail === "vivek@collectwise.com"){
      window.location.href = `https://admin.collectwise.com/?id=${props.debtorId}`
    } else {
      navigate(`debtor/${props.id}`)
    }
  }
  }} {...props} />;
}


const ClientsListCard = React.forwardRef(ClientsListCard_);

export default ClientsListCard;
